<template>
  <div class="lib__form__main" data-cy="other-equipment-meter-component">
    <ValidationObserver ref="validator" slim>
      <div class="lib__form__main__content">
        <header class="lib__form__main__header">
          <h2 class="lib__h2">{{ $t('wantedConfiguration.otherEquipmentTitle') }}</h2>
        </header>
        <div class="lib__feedback lib__feedback--alert" data-cy="meter-under-reserve-of-availability">
          <div class="lib__feedback__icon">
            <i class="fas fa-exclamation-circle"></i>
          </div>
          <div class="lib__feedback__content">
            <p>{{ $t('meter.underReserveOfAvailability') }}</p>
          </div>
        </div>

        <other-equipment-electricity-meter-form :tarifications="electricityTarifications" :tensions="electricityTensions" :value="configurationInfo.electricityMeter"></other-equipment-electricity-meter-form>

        <fieldset class="lib__form__fieldset">
          <legend class="lib__form__legend">{{ $t('connectionPeriod.wantedWorkDates') }}</legend>
          <monthly-selector :month.sync="configurationInfo.month" :year.sync="configurationInfo.year" :years="5" required></monthly-selector>
          <collapsable-text-area :max='500' :add-label="$t('meter.form.remarks')" :label="$t('meter.form.remarks')" v-model="configurationInfo.remark"></collapsable-text-area>
        </fieldset>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import { helper, meterService } from '@/services'
import Step from '@/components/steps/Step'
import OtherEquipmentElectricityMeterForm from '@/components/inputs/Configuration/OtherEquipmentElectricityMeterForm.vue'
import { State, Mutation } from 'vuex-class'
import { OtherEquipmentConfigurationInfo, MeterElectricityType, MeterElectricityTension } from '@/models'

@Component({
  name: 'configuration-info-step',
  components: {
    OtherEquipmentElectricityMeterForm,
  }
})
export default class ConfigurationInfoStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'otherEquipmentConnection' })
  public requestId!: string
  @State('electricityTensions', { namespace: 'otherEquipmentConnection/configurationInfo' })
  public readonly electricityTensions!: MeterElectricityTension[]

  @State('configurationInfo', { namespace: 'otherEquipmentConnection/configurationInfo' })
  public configurationInfoState!: OtherEquipmentConfigurationInfo | null

  public electricityTarifications: MeterElectricityType[] = ['dual', 'simple', 'nightOnly']

  public configurationInfo: OtherEquipmentConfigurationInfo = {
    electricityMeter: meterService.getDefaultOtherEquipmentElectricityMeter('mono230V'),
    month: null,
    year: null,
    remark: null
  }
  //#endregion

  //#region [Computed]
  //#endregion

  //#region [Mutation]
  @Mutation('STORE', { namespace: 'otherEquipmentConnection/configurationInfo' })
  private store!: (index: OtherEquipmentConfigurationInfo | null) => void
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
    if (this.configurationInfoState !== null) {
      this.configurationInfo = helper.clone(this.configurationInfoState)
    }
  }

  public async save(next: boolean, isValid: boolean) {
    if (isValid) {
      this.$appInsights.trackEvent('WR_OEC_StepConfigurationInfo_Validated', {
        Segment: 'WR_OEC',
        WebRef: this.requestId
      })
    }

    this.store(this.configurationInfo)
  }
  //#endregion
}
</script>